function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import classNames from 'classnames';
var Switch = React.forwardRef(function (props, ref) {
  var _classNames;

  var mergedRef = ref || React.createRef();
  var initChecked = false;

  if ('checked' in props) {
    initChecked = !!props.checked;
  } else {
    initChecked = !!props.defaultChecked;
  }

  var _React$useState = React.useState(initChecked),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      checked = _React$useState2[0],
      setChecked = _React$useState2[1];

  React.useEffect(function () {
    var autoFocus = props.autoFocus,
        disabled = props.disabled;

    if (autoFocus && !disabled) {
      mergedRef.current.focus();
    }
  }, [props.autoFocus]);
  React.useEffect(function () {
    if ('checked' in props) {
      setChecked(!!props.checked);
    }
  }, [props.checked]);

  var setInternalChecked = function setInternalChecked(checked, e) {
    var disabled = props.disabled,
        onChange = props.onChange;

    if (disabled) {
      return;
    }

    if (!('checked' in props)) {
      setChecked(checked);
    }

    if (onChange) {
      onChange(checked, e);
    }
  };

  var handleClick = function handleClick(e) {
    var onClick = props.onClick;
    var newChecked = !checked;
    setInternalChecked(newChecked, e);

    if (onClick) {
      onClick(newChecked, e);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 37) {
      // Left
      setInternalChecked(false, e);
    } else if (e.keyCode === 39) {
      // Right
      setInternalChecked(true, e);
    }
  }; // Handle auto focus when click switch in Chrome


  var handleMouseUp = function handleMouseUp(e) {
    mergedRef.current.blur();

    if (props.onMouseUp) {
      props.onMouseUp(e);
    }
  };

  var className = props.className,
      prefixCls = props.prefixCls,
      disabled = props.disabled,
      loadingIcon = props.loadingIcon,
      checkedChildren = props.checkedChildren,
      unCheckedChildren = props.unCheckedChildren,
      onChange = props.onChange,
      restProps = _objectWithoutProperties(props, ["className", "prefixCls", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onChange"]);

  var switchClassName = classNames((_classNames = {}, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, "".concat(prefixCls, "-checked"), checked), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
  return React.createElement("button", Object.assign({}, restProps, {
    type: "button",
    role: "switch",
    "aria-checked": checked,
    disabled: disabled,
    className: switchClassName,
    ref: mergedRef,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    onMouseUp: handleMouseUp
  }), loadingIcon, React.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }, checked ? checkedChildren : unCheckedChildren));
});
Switch.displayName = 'Switch';
Switch.defaultProps = {
  prefixCls: 'rc-switch',
  checkedChildren: null,
  unCheckedChildren: null,
  className: '',
  defaultChecked: false
};
export default Switch;